<template>
    <main-modal :title="'ecommerce.delivery_detail'" @closeModal="$emit('closeModal')" class="delivery-detail">
        <div class="row m-0">
            <div class="col-md-12">
                <div class="d-flex align-items-center mb-2 mt-4">
                    <icon-money :size="25" class="me-2"/>
                    <b class="title-16 mb-0">{{$t("ecommerce.base_price")}}</b>
                    <span class="ms-2">{{delivery.base_price | moneyFormat}}</span>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered mb-0 size-16">
                        <thead style="border-bottom: 2px solid #dee2e6;">
                            <tr class="align-center text-center">
                                <th scope="col">{{$t("ecommerce.rates")}}</th>
                                <th scope="col">{{$t("ecommerce.your_order")}}</th>
                                <th scope="col">{{$t("ecommerce.cost")}}</th>
                                <th scope="col">{{$t("ecommerce.subtotal_delivery")}}</th>
                            </tr>
                        </thead>
                        <tbody class="color-dark-gray-300 text-center">
                            <tr>
                                <td class="title-15 mb-0">{{$t("ecommerce.minute")}}</td>
                                <td>{{delivery.minutes || delivery.min}} Min</td>
                                <td>{{delivery.price_per_min | moneyFormat}}</td>
                                <td>{{delivery.price_per_min | moneyFormatMultiply(delivery.minutes || delivery.min )}}</td>
                            </tr>
                            <!-- <tr v-if="delivery.price_per_quantity != 0">
                                <td class="title-15 mb-0">{{$t("ecommerce.quantity")}}</td>
                                <td>{{quantity}}</td>
                                <td>{{delivery.price_per_quantity}}</td>
                                <td>{{delivery.price_per_quantity}}</td>
                            </tr> -->
                            <tr>
                                <td class="title-15 mb-0">{{$t("ecommerce.kilometer")}}</td>
                                <td>{{delivery.kilometers || delivery.km}} km</td>
                                <td>{{delivery.price_per_km | moneyFormat}}</td>
                                <td>{{delivery.price_per_km | moneyFormatMultiply(delivery.kilometers || delivery.km )}}</td>
                            </tr>
                                <tr>
                                <td class="title-15 mb-0">{{$t("ecommerce.base_price")}}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>{{delivery.base_price}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-3 d-flex justify-content-end">
                    <h6 class="mb-0 color-main-red weight-600 size-16">{{$t("ecommerce.total_cost")}} <b class="ms-2 color-main-navy weight-500">{{(delivery.amount || delivery.price) | moneyFormat}}</b></h6>
                </div>
            </div>
            <div class="col-md-12 mt-1 map">
                <div class="d-flex align-items-center mb-2">
                    <icon-pin :size="20" class="me-2"/>
                    <span class="title-16 mb-0">{{$t("ecommerce.order_delivery_route")}}</span>
                </div>
                <div class="delivery-map">
                    <MglMap style="height: 500px;" ref="map" :center="[long, lat]" :accessToken="accessToken" :zoom="10" :dragRotate="false"  @load="onMapLoaded" :mapStyle="mapStyle" >
                        <MglGeolocateControl :trackUserLocation="true" position="top-right" />
                        <MglMarker :coordinates="[long, lat]" color="#BC2C35"/>
                        <MglMarker :coordinates="[branch.longitude, branch.latitude]" color="#BC2C35">
                            <div slot="marker" class="icon-store">
                                <icon-store :size="25" :color="'var(--main-red)'"/>
                            </div>
                        </MglMarker>
                        <MglNavigationControl position="top-right"/>
                    </MglMap>
                </div>
            </div>
        </div>
    </main-modal>
</template>

<script>
import { MglMap, MglMarker, MglGeolocateControl, MglNavigationControl } from 'v-mapbox'
import Mapbox from "mapbox-gl";
import { addressesMixin } from '../../helpers/mixins/addresses-mixin'
import MainModal from '../../../../common/components/modals/MainModal.vue';
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css";
import IconPin from '../../../../common/components/svg/IconPin.vue';
import IconMoney from '../../../../common/components/svg/IconMoney.vue';
import IconStore from '../../../delivery/assets/svg/IconStore.vue';
export default {
    name: "DeliveryDetail",
    components:{
        // IconMoney,
        MglMap,
        MglMarker,
        MglGeolocateControl,
        MglNavigationControl,
        MainModal,
        IconPin,
        IconMoney,
        IconStore,
    },
    props:{
        lat:{
            type: [Number, String]
        },
        long:{
            type: [Number, String]
        },
        branch:{
            type: Object
        },
        delivery:{
            type: Object
        },
        quantity:{
            type: Number
        }
    },
    mixins: [addressesMixin],
    computed:{
        sources() {
            let sources = [];
            for (let layer of this.layers){
                sources.push({
                'type': 'geojson',
                'data': layer
                })
            }
            return sources;
        },  
    },
    data() {
        return {
            accessToken: 'pk.eyJ1IjoicmVwZG9tIiwiYSI6ImNrMTV6cGN4bTEwbTQzaHJzM3FxYXl3aXgifQ.Vue3ItLfwfA6xmA20Xd-tA', // your access token. Needed if you using Mapbox maps
            mapStyle: 'mapbox://styles/repdom/ck1to2pew6n411cqrc1fd8cga', // your map style
            center: [-70.70238447994983, 19.45556310283655],
            layers: []
        }
    },
    methods:{
        async onMapLoaded(event){
            await this.getLimits(this.branch)
            this.mapbox = Mapbox;
            this.sources.forEach((source, id)=>{
                event.map.addSource('limit-areas-'+id, source);
                event.map.addLayer(
                    {
                    'id': 'limit-areas-fill-'+id,
                    'type': 'fill',
                    'source': 'limit-areas-'+id,
                    'layout': {},
                    'paint': {
                        'fill-color': '#5A8CDB',
                        'fill-opacity': 0.3
                    }
                    },
                );

            })
            event.map.on('style.load', async () => {
                this.sources.forEach((source, id)=>{
                event.map.addSource('limit-areas-'+id, source);
                event.map.addLayer(
                    {
                        'id': 'limit-areas-fill-'+id,
                        'type': 'fill',
                        'source': 'limit-areas-'+id,
                        'layout': {},
                        'paint': {
                        'fill-color': '#c40316',
                        'fill-opacity': 0.5
                        }
                    },
                );

                })
            });
            const animationOptions = {
                animate: true, duration: 4000, essential: true
            }
            setTimeout(() => {
                    event.map.zoomTo(14, animationOptions)
            }, 2000);
            this.addRoute(this.delivery.coords)
        },
        addRoute(coords){
            if (this.$refs.map.map.getSource('route')) {
                this.$refs.map.map.removeLayer('route');
                this.$refs.map.map.removeSource('route')
            } else{
                this.$refs.map.map.addLayer({
                "id": "route",
                "type": "line",
                "source": {
                    "type": "geojson",
                    "data": {
                    "type": "Feature",
                    "properties": {},
                    "geometry": coords
                    }
                },
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-color": "#3b9ddd",
                    "line-width": 8,
                    "line-opacity": 0.8
                }
                });
                }
        }
    }
}
</script>

<style scoped>
    .table-details{
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #d8e0eb;
        margin: 0;
    }
    .delivery-map{
        border-radius: 10px;
        overflow: hidden;
    }
    .table-bordered {
        border-top-right-radius: 15px !important;
        border-top-left-radius: 15px !important;
    }
    td{
        width: 25%;
    }
    .legend-map{
        height: 20px;
        width: 20px;
        background: #a4bbde;
        border-radius: 3px;
    }
    .icon-store{
        background-color: #fff;
        border-radius: 50%;
        padding: 5px;
    }
</style>
